import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
const [activeSection, setActiveSection] = useState('hero');
const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
const location = useLocation();

const onHome = location.pathname === '/';

useEffect(() => {
if (!onHome) return;
const handleScroll = () => {
const sections = ['hero', 'about', 'services', 'benefits', 'process', 'experience', 'testimonials', 'contact'];
const currentSection = sections.find(section => {
const el = document.getElementById(section);
if (el) {
const rect = el.getBoundingClientRect();
return rect.top <= 100 && rect.bottom >= 100;
}
return false;
});
if (currentSection) setActiveSection(currentSection);
};
window.addEventListener('scroll', handleScroll);
return () => window.removeEventListener('scroll', handleScroll);
}, [onHome]);

return (
<header className="header" role="banner">
<a href="#main" className="skip-link">Przejdź do treści</a>
<div className="container">
<div className="header-content">
<Link to="/" className="logo" aria-label="JASNE GRANTY - Strona główna">
JASNE GRANTY
</Link>

      <nav role="navigation" aria-label="Nawigacja główna">
        <ul className="nav-list">
          {onHome ? (
            <>
              <li>
                <ScrollLink to="about" smooth offset={-70} duration={500} className={`nav-link ${activeSection==='about'?'active':''}`}>
                  O nas
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="services" smooth offset={-70} duration={500} className={`nav-link ${activeSection==='services'?'active':''}`}>
                  Usługi
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="benefits" smooth offset={-70} duration={500} className={`nav-link ${activeSection==='benefits'?'active':''}`}>
                  Korzyści
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="experience" smooth offset={-70} duration={500} className={`nav-link ${activeSection==='experience'?'active':''}`}>
                  Doświadczenie
                </ScrollLink>
              </li>
              <li>
                <ScrollLink to="contact" smooth offset={-70} duration={500} className={`nav-link ${activeSection==='contact'?'active':''}`}>
                  Kontakt
                </ScrollLink>
              </li>
            </>
          ) : (
            <>
              <li><Link className="nav-link" to="/">Strona główna</Link></li>
            </>
          )}
          <li><Link className={`nav-link ${location.pathname.startsWith('/blog') ? 'active' : ''}`} to="/blog">Blog</Link></li>
        </ul>
      </nav>

      <button 
        className="mobile-menu-toggle"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Otwórz menu"
        aria-expanded={mobileMenuOpen}
      >
        <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
      </button>
    </div>
  </div>
</header>

);
};

export default Header;
